import { AdornisRouter } from '@adornis/base/client/a-router';
import { BaseQLClient } from '@adornis/baseql/client/baseqlClient';
import { QueryCache } from '@adornis/baseql/client/requestHandlers/queryCache';
import { DesignSystem, elevation } from '@adornis/chemistry/elements/theming/design';
import merge from 'deepmerge';
import './main-element';

AdornisRouter.init(['/:page']);

export const colors = {
  blue: '#054a8aff',
  gray: '#D1D3D1',
  orange: '#F5C288',
  green: '#A5DDCA',
  red: '#ED79A6',
  lightred: '#F3B7D7',
  yellow: '#F9F9A0',
};

DesignSystem.setTheme(
  'Hydrogen',
  merge(DesignSystem.currentTheme.getValue(), {
    colors: {
      primary: '#AFCA00', //
      accent: '#59b7ff', //
      ...colors,
    },
    sizes: { borderRadius: '5px' },
    shadows: elevation,
  }),
);

DesignSystem.useTheme('Hydrogen');

// Setup BaseQL Client
const transportHandler = BaseQLClient.createTransportHandler();
const queryCache = new QueryCache(transportHandler);
BaseQLClient.initHandler(queryCache);
// AdornisUser.subscribeCurrentUser();
